import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";
import { Button } from "wiz-front-shared/components/button/Button";
import { recoverHistoryDepthAtom, setRecoveryExiting } from "store/recoverStore";
import './Recover.css';

// Step6: 비밀번호 재설정 완료 (기존 Step5)
export const RecoverStep6 = () => {
    const { t } = useTranslation();
    const historyDepth = useAtomValue(recoverHistoryDepthAtom);

    // /signin 으로 빠져나가기 — flicker 없이 history pop (재마운트되는 /account-recovery 없음)
    const goSignIn = () => {
        setRecoveryExiting(true);
        window.history.go(-(historyDepth + 1));
    };

    // 일정 시간 후 자동으로 SignIn 화면으로 이동
    useEffect(() => {
        const timer = setTimeout(() => {
            goSignIn();
        }, 3000);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="recover-done">
            <span className="recover-done-title">{t("recover.step5.title")}</span>
            <span className="recover-done-message">{t("recover.step5.message")}</span>

            <div className="recover-bottom-btn">
                <Button
                    text={t("recover.step5.goSignInBtn")}
                    onPress={goSignIn}
                />
            </div>
        </div>
    );
};
